import { render, staticRenderFns } from "./Kidney.vue?vue&type=template&id=344ab543"
import script from "./Kidney.vue?vue&type=script&lang=ts"
export * from "./Kidney.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports